import { checkboxStyles as o } from "./checkbox.js";
import { radioButtonStyles as r } from "./radio.js";
const e = {
  checkbox: o,
  radio: r
};
export {
  e as forms
};
